import { useEffect, useState } from 'react'
import moment from 'moment'

export const ReportTimer = ({ citizenSendDate, completedAt, statusId }) => {
  const [activeTime, setActiveTime] = useState('')

  useEffect(() => {
    if (citizenSendDate && statusId !== 7 && statusId !== 15) {
      const interval = setInterval(() => {
        const startDate = moment(citizenSendDate)
        const now = moment()
        const duration = moment.duration(now.diff(startDate))

        let textTime = ''
        if (duration.years() > 0) textTime += `${duration.years()}A `
        if (duration.months() > 0) textTime += `${duration.months()}M `
        if (duration.days() > 0) textTime += `${duration.days()}D `
        if (duration.hours() > 0) textTime += `${duration.hours()}h `
        textTime += `${duration.minutes()}m ${duration.seconds()}s`

        setActiveTime(textTime)
      }, 1000)

      return () => clearInterval(interval)
    } else if (completedAt && (statusId === 7 || statusId === 15)) {
      const startDate = moment(citizenSendDate)
      const endDate = moment(completedAt)
      const duration = moment.duration(endDate.diff(startDate))

      let textTime = ''
      if (duration.years() > 0) textTime += `${duration.years()}A `
      if (duration.months() > 0) textTime += `${duration.months()}M `
      if (duration.days() > 0) textTime += `${duration.days()}D `
      if (duration.hours() > 0) textTime += `${duration.hours()}h `
      textTime += `${duration.minutes()}m ${duration.seconds()}s`

      setActiveTime(textTime)
    }
  }, [citizenSendDate, completedAt, statusId])

  return (
    <div className="d-flex flex-column align-items-end border border-secondary py-2 px-2 rounded">
      <div style={{ fontSize: 12 }}>
        <i className="fas fa-clock mr-1" />
        Tiempo activo
      </div>
      <div>{activeTime}</div>
    </div>
  )
}

export default ReportTimer
